import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import OrderService from '../../../data/pages/order/OrderService';
import LightBoxComponent from '../../shared/lightbox/components/LightBoxComponent';
import LoginComponent from '../../shared/Login/components/LoginComponent';
import isMobile from 'is-mobile';
import Menu from '../../shared/header/components/Menu';

import '../style/MenuStyle.scss';
import AuthenticationService from '../../../services/AuthenticationService';
import { withTranslation } from 'react-i18next';
import OrderCartAuthentication from '../../ordercartauthentication/components/OrderCartAuthentication';
import ButtonComponent from '../../shared/button/components/ButtonComponent';

const RenderLightBox = (props) => {
    const { show, handleClick } = props;

    return (
        <LightBoxComponent isOpen={show} handleClick={handleClick} handleEventClose={handleClick}>
            <LoginComponent />
        </LightBoxComponent>
    );
};

class MenuComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLightBox: false,
            loading: true,
            offsetDropdown: 60,
            segmentsOpened: false,
            projectsOpened: false,
            quantityUnreadMessages: 0,
        };
    }

    showLightBox() {
        this.setState({
            showLightBox: true,
        });
    }

    closeLightBox() {
        this.setState({
            showLightBox: false,
        });
    }

    handleClickProjects() {
        this.setState({ projectsOpened: !this.state.projectsOpened });
    }

    async componentDidMount() {
        let orderService = new OrderService();
        if (window.localStorage.getItem('access_token')) {
            let quantityUnreadMessages = (await orderService.getMessages()) || 0;

            this.setState({
                loading: false,
                quantityUnreadMessages: quantityUnreadMessages,
            });
        } else {
            this.setState({
                loading: false,
            });
        }

    }

    active(ev) {
        if (document.getElementsByClassName('active')[0] !== undefined) {
            document.getElementsByClassName('active')[0].classList.remove('active');
        }
        ev.target.closest('li').classList.add('active');
    }

    handleClick(endPoint, ev) {
        this.active(ev);
        this.props.handleClick();
        this.props.getProducts(endPoint);
    }

    closeMenuMobile() {
        let menu = document.getElementById('navItems');
        menu.style.display = 'none';
    }

    static isNotLogged() {
        return window.localStorage.getItem('user') === null;
    }

    getMarginDropDownMenu() {
        return `-${this.state.offsetDropdown / 2}.px`;
    }

    getWidthDropDownMenu(menu) {
        const menuEl = document.getElementById(`dropdown-wrapper-${menu}`);

        if (menuEl) {
            return `${menuEl.offsetWidth + this.state.offsetDropdown}.px`;
        }
    }

    openMenuMobile() {
        let menu = document.getElementById('navItems');
        menu.style.display = 'block';
    }

    render() {
        const { t } = this.props;
        const xAccountLogo = localStorage.getItem('xAccountLogo');

        return (
            <div className='menu-component'>
                <div
                    className="open-menu-wrapper"
                >     
                    <a href='/'>
                        <img src={xAccountLogo} alt='' />
                    </a>

                    <div className='MenuResponsive' id='MenuResponsive' onClick={() => this.openMenuMobile()}>
                        <span />
                        <span />
                        <span />
                    </div>
                </div>
                {isMobile() && (
                    <div className='logo-wrapper-mobile'>
                        <img src={xAccountLogo} alt='' />
                    </div>
                )}
                <nav id='navItems'>
                    <div className={`HeaderMobile show-mb ${this.state.openMenu ? "showMenu" : ""}`}>
                        <div className="logo-wrapper mobile logo-wrapper--xAccount">
                            <img
                                src={xAccountLogo}
                                className="logo-desk"
                                alt="Blank"
                                onClick={() => {
                                    return window.location.pathname !== "/" ? this.back() : "";
                                }}
                            />

                            <div id='closeMenu' onClick={() => this.closeMenuMobile()}>
                                <img src='/images/close-icon.svg' alt="Close"/>
                            </div>
                        </div>
                    </div>

                    <div
                        className={`centerNav ${this.state.segmentsOpened ? 'segments-open' : ''} ${this.state.projectsOpened ? 'projects-open' : ''
                            }`}>
                        {/* {isMobile() && <SearchComponent />} */}
                        <div className='left'>
                            <div className='logo-wrapper'>
                                <a href='/'>
                                    <img src={xAccountLogo} alt='' />
                                </a>
                            </div>
                            {this.state.loading ? (
                                <ul>
                                    <li>
                                        {
                                            window.localStorage.getItem('user_stype') ? (
                                                <>
                                                    {
                                                        window.localStorage.getItem('user_stype') !== 'buyer' ? (
                                                            <Link onClick={() => {
                                                                AuthenticationService.getInfoUser().then((data) => {window.location.href = `/${data.seller_slug}`})
                                                            }}>
                                                                {t('My Brand', 'My Brand')}
                                                            </Link>
                                                        ) : (
                                                            <Link to='/brands'>
                                                                {t('Our Brands', 'Our Brands')}
                                                            </Link>
                                                        )
                                                    }
                                                </>
                                            ) : (
                                                <>{t('Brands', 'Brands')}</>
                                            )
                                        }
                                    </li>
                                </ul>
                            ) : localStorage.getItem('access_token') ? (
                                <>
                                    {
                                        window.localStorage.getItem('user_stype') !== 'buyer' ? (
                                            <ul>
                                                <li>
                                                    <Link to={`/${window.localStorage.getItem('seller_slug')}`}>
                                                        {t('My Brand', 'My Brand')}
                                                    </Link>
                                                </li>
                                            </ul>
                                        ) : <div
                                                className={`itens`}
                                                >
                                                <ul>
                                                    <li>
                                                    <a
                                                        onClick={() =>
                                                        this.setState({ openMenu: false, selectedIndexMenu: 1 })
                                                        }
                                                        href="/brands"
                                                        className={
                                                        this.state.selectedIndexMenu === 1 ? "selected" : ""
                                                        }
                                                    >
                                                        {t("Brands", "Brands")}
                                                    </a>
                                                    </li>
                                                    <li>
                                                    <a
                                                        onClick={() =>
                                                        this.setState({ openMenu: false, selectedIndexMenu: 2 })
                                                        }
                                                        href="/brands?segments=13"
                                                        className={
                                                        this.state.selectedIndexMenu === 2 ? "selected" : ""
                                                        }
                                                    >
                                                        {t("Women", "Women")}
                                                    </a>
                                                    </li>
                                                    <li>
                                                    <a
                                                        onClick={() =>
                                                        this.setState({ openMenu: false, selectedIndexMenu: 3 })
                                                        }
                                                        href="/brands?segments=14"
                                                        className={
                                                        this.state.selectedIndexMenu === 3 ? "selected" : ""
                                                        }
                                                    >
                                                        {t("Men", "Men")}
                                                    </a>
                                                    </li>
                                                    <li>
                                                    <a
                                                        onClick={() =>
                                                        this.setState({ openMenu: false, selectedIndexMenu: 4 })
                                                        }
                                                        href="/brands?segments=15"
                                                        className={
                                                        this.state.selectedIndexMenu === 4 ? "selected" : ""
                                                        }
                                                    >
                                                        {t("Children", "Children")}
                                                    </a>
                                                    </li>
                                                    <li>
                                                    <a
                                                        onClick={() =>
                                                        this.setState({ openMenu: false, selectedIndexMenu: 5 })
                                                        }
                                                        href="/brands?segments=16"
                                                        className={
                                                        this.state.selectedIndexMenu === 5 ? "selected" : ""
                                                        }
                                                    >
                                                        {t("Home & Beauty", "Home & Beauty")}
                                                    </a>
                                                    </li>
                                                </ul>
                                                </div>
                                    }
                                </>
                            ) : (
                                <ul>
                                    <li>
                                        {
                                            window.localStorage.getItem('user_stype') ? (
                                                <>
                                                    {
                                                        window.localStorage.getItem('user_stype') !== 'buyer' ? (
                                                            <Link onClick={() => {
                                                                AuthenticationService.getInfoUser().then((data) => {window.location.href = `/${data.seller_slug}`})
                                                            }}>
                                                                {t('My Brand', 'My Brand')}
                                                            </Link>
                                                        ) : (
                                                            <Link to='/brands'>
                                                                {t('Our Brands', 'Our Brands')}
                                                            </Link>
                                                        )
                                                    }
                                                </>
                                            ) : (
                                                <Link to='/brands'>
                                                    {t('Brands', 'Brands')}
                                                </Link>
                                            )
                                        }
                                    </li>
                                </ul>
                            )}
                        </div>
                        {MenuComponent.isNotLogged() ? (
                            <div id='LoginMobile'>
                                <p onClick={() => this.showLightBox()}>{t('sign in', 'sign in')}</p>
                                {this.state.showLightBox && (
                                    <RenderLightBox
                                        show={this.state.showLightBox}
                                        handleClick={() => this.closeLightBox()}
                                    />
                                )}
                            </div>
                        ) : (
                            <div id='LoginMobile'>
                                {window.localStorage.getItem('user_stype') !== 'buyer' ? (
                                    <ul>
                                        <li>
                                            <Link to={`/${window.localStorage.getItem('seller_slug')}`}>
                                                {t('My Brand', 'My Brand')}
                                            </Link>
                                        </li>
                                    </ul>
                                ) : (
                                    <ul>
                                        <li>
                                            <Link to='/brands'>{t('Brands', 'Brands')}</Link>
                                        </li>
                                        <li>
                                            <Link to='/brands?segments=13'>{t('Women', 'Women')}</Link>
                                        </li>
                                        <li>
                                            <Link to='/brands?segments=14'>{t('Men', 'Men')}</Link>
                                        </li>
                                        <li>
                                            <Link to='/brands?segments=15'>{t('Children', 'Children')}</Link>
                                        </li>
                                        <li>
                                            <Link to='/brands?segments=16'>{t('Home & Beauty', 'Home & Beauty')}</Link>
                                        </li>
                                    </ul>
                                )}
                            </div>
                        )}
                        <div className='right'>
                            <OrderCartAuthentication
                                cartCount={this.state.cartCount}
                                orderCount={this.state.orderCount}
                                handleClick={() => this.showLightBox()}
                            />
                            {window.localStorage.getItem('user_stype') && <Menu />}
                        </div>

                        <div className="wrapper-global-links-and-social">
                            <div className="new-menu__list--item">
                                <div className="new-menu__list--item__subitem">
                                    <a href="https://www.blanc.global/">About BLANC*</a>
                                    <a href="https://news.blancfashion.com/">News and Views</a>
                                    <a href="https://www.blanc.global/contact-us">Get in touch</a>
                                </div>
                            </div>

                            <div className="bottom-items icons">
                                <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/blancfashionglobal/">
                                    <img src="/images/icon-instagram.svg" alt="Instagram"/>
                                </a>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/blancfashionbr/">
                                    <img src="/images/icon-facebook.svg" alt="Facebook"/>
                                </a>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/blanc-fashion/">
                                    <img src="/images/icon-linkedin.svg" alt="Linkedin"/>
                                </a>
                            </div>
                        </div>
                    </div>
                </nav>
                <div id='shadowNav'></div>
            </div>
        );
    }
}

export default withTranslation()(MenuComponent);
